import React, { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import useAuth from '../../hooks/useAuth'
import PageLayout from '../common/layout/PageLayout'
import NotificationStats from './NotificationStats'
import NotificationControls from './NotificationControls'
import featureFlags from '../../config/featureFlags'
import './NotificationDashboard.css'

/**
 * NotificationDashboard - Admin dashboard for SMS notification monitoring and configuration
 *
 * Feature-gated by SMS_NOTIFICATIONS flag
 * This component should only be accessible when the feature flag is enabled
 */
function NotificationDashboard() {
  const { isAdmin, loading } = useAuth()
  const [activeTab, setActiveTab] = useState('stats')

  // Feature flag check - show message if accessed directly when flag is off
  if (!featureFlags.SMS_NOTIFICATIONS) {
    return (
      <PageLayout title="SMS Notifications">
        <div className="container py-5">
          <div className="alert alert-info" role="alert">
            <h4 className="alert-heading">
              <i className="bi bi-info-circle me-2"></i>
              Feature Not Available
            </h4>
            <p className="mb-0">
              The SMS Notifications dashboard is currently disabled. This
              feature is under development and will be available soon.
            </p>
          </div>
        </div>
      </PageLayout>
    )
  }

  // Loading state
  if (loading) {
    return (
      <PageLayout title="SMS Notifications">
        <div className="container py-4">
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </PageLayout>
    )
  }

  // Admin check
  if (!isAdmin) {
    return (
      <PageLayout title="SMS Notifications">
        <div className="container py-4">
          <div className="alert alert-danger" role="alert">
            <h4 className="alert-heading">
              <i className="bi bi-exclamation-triangle me-2"></i>
              Access Denied
            </h4>
            <p className="mb-0">
              You must be an administrator to access this page.
            </p>
          </div>
        </div>
      </PageLayout>
    )
  }

  return (
    <PageLayout title="SMS Notifications">
      <div className="container-fluid py-3 py-md-4">
        {/* Header */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
              <div>
                <h1 className="h3 mb-1">
                  <i className="bi bi-bell-fill me-2 text-primary"></i>
                  SMS Notification Dashboard
                </h1>
                <p className="text-muted mb-0">
                  Monitor notification delivery, manage configuration, and track
                  costs
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="row">
          <div className="col-12">
            <Tabs
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              className="mb-3"
              id="notification-dashboard-tabs"
            >
              <Tab
                eventKey="stats"
                title={
                  <span>
                    <i className="bi bi-graph-up me-2"></i>
                    Stats & Monitoring
                  </span>
                }
              >
                <NotificationStats />
              </Tab>

              <Tab
                eventKey="controls"
                title={
                  <span>
                    <i className="bi bi-sliders me-2"></i>
                    Configuration
                  </span>
                }
              >
                <NotificationControls />
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    </PageLayout>
  )
}

export default NotificationDashboard
